<template>
    <v-card class="v-card-in-dialog  router-content">    
        <div class="with_back_btn_con">
            <div class="go_back_container">
                <span class="icon-next mr-3"  @click="CloseModal()"><IconBase width="24" height="24"><IconArrowBack /></IconBase></span><span class="ap_text"> Add Educator </span>
            </div>
        </div>    

        <v-card-text class="pb-4 dialog-educator">
            <v-container grid-list-xl>
                <v-layout row wrap>
                    <form id="formNewEducator" data-vv-scope="formNewEducator" class="standard-form">
                        <v-layout row wrap class="mb-3">
                            <v-flex xs12 sm12 md12 lg12 xl12>
                                <p class="subheading mb-1 mt-3 text-xs-center">Please select the type of the Educator that you would like to add to the policy. </p>
                            </v-flex>
                            <v-flex xs12 sm12 md12 lg12 xl12>
                                <div class="educator-info">
                                    <p class="mb-0"><span class="icon-enclosed"><IconBase width="16" height="16"><IconDualEducator /></IconBase></span></p>
                                    <p class="mb-0">A dual educator is a parter or assistant regularly working with you to provide authorised care. 
        A Relief Educator provides care in your absence such as when you take leave or are unwell.</p>
                                </div>
                            </v-flex>
                        </v-layout>

                        <v-layout row wrap class="mb-5">
                            <v-flex xs12 sm12 md6 lg6 xl6>
                                <v-btn id="relief_educator" class="button-item wh-btn" :class="{ 'selected': educator_type == 'Relief Educator'}" flat block @click="educator_type = 'Relief Educator'">Relief Educator</v-btn>
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6>
                                <v-btn id="dual_educator" class="button-item wh-btn" :class="{ 'selected': educator_type == 'Dual Educator'}" flat block @click="educator_type = 'Dual Educator'">Dual Educator</v-btn>
                            </v-flex>
                        </v-layout>

                        <v-layout row wrap>
                            <v-flex xs12 sm12 md12 lg12 xl12 class="text-xs-center">
                                <label class="subheading">What is their name?</label>
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6>
                                <label for="first_name" class="subheading">First name</label>
                                <v-text-field
                                    v-model="first_name"
                                    id="first_name"
                                    label="Enter your first name"
                                    v-validate="'required|max:100'" 
                                    :error-messages="errors.first('formNewEducator.first_name')"
                                    data-vv-name="first_name"
                                    data-vv-scope="formNewEducator"
                                    :class="{valid_entry: fields.$formNewEducator && fields.$formNewEducator.first_name && fields.$formNewEducator.first_name.valid}"
                                    single-line
                                    outline
                                    class="full-width"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6>
                                <label for="last_name" class="subheading">Last name</label>
                                <v-text-field
                                    v-model="last_name"
                                    id="last_name"
                                    label="Enter your last name"
                                    v-validate="'required|max:100'" 
                                    :error-messages="errors.first('formNewEducator.last_name')"
                                    data-vv-name="last_name"
                                    data-vv-scope="formNewEducator"
                                    :class="{valid_entry: fields.$formNewEducator && fields.$formNewEducator.last_name && fields.$formNewEducator.last_name.valid}"
                                    single-line
                                    outline
                                    class="full-width"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>

                        <v-layout row wrap>
                            <v-flex xs12 sm12 md12 lg12 xl12 class="text-xs-center">
                                <label for="" class="subheading">What is their date of birth</label>
                            </v-flex>
                            <v-flex xs12 sm12 md4 lg4 xl4>
                                <label for="" class="subheading">Day</label>
                                <v-overflow-btn
                                id="birth_day"
                                v-model="birth_day"
                                label="dd"
                                :items="days"
                                v-validate="'required'" 
                                :error-messages="errors.first('formNewEducator.birth_day')"
                                data-vv-name="birth_day" 
                                data-vv-scope="formNewEducator"
                                data-vv-validate-on="input"
                                flat
                                editable
                                outline
                                return-object
                                :class="{valid_entry: fields.$formNewEducator && fields.$formNewEducator.birth_day && fields.$formNewEducator.birth_day.valid}"
                                
                                ></v-overflow-btn>
                            </v-flex>
                            <v-flex xs12 sm12 md4 lg4 xl4>
                                <label for="" class="subheading">Month</label>
                                <v-overflow-btn
                                id="birth_month"
                                v-model="birth_month"
                                label="mm"
                                :items="month_of_the_year"
                                v-validate="'required'" 
                                :error-messages="errors.first('formNewEducator.birth_month')"
                                data-vv-name="birth_month"
                                data-vv-scope="formNewEducator"
                                data-vv-validate-on="input"
                                flat
                                editable
                                outline
                                return-object
                                :class="{valid_entry: fields.$formNewEducator && fields.$formNewEducator.birth_month && fields.$formNewEducator.birth_month.valid}"
                                
                                ></v-overflow-btn>
                            </v-flex>
                            <v-flex xs12 sm12 md4 lg4 xl4>
                                <label for="" class="subheading">Year</label>
                                <v-overflow-btn
                                id="birth_year"
                                v-model="birth_year"
                                label="yyyy"
                                :items="years"
                                v-validate="'required'" 
                                :error-messages="errors.first('formNewEducator.birth_year')"
                                data-vv-name="birth_year"
                                data-vv-scope="formNewEducator"
                                data-vv-validate-on="input"
                                return-object
                                editable
                                flat
                                outline
                                :class="{valid_entry: fields.$formNewEducator && fields.$formNewEducator.birth_year && fields.$formNewEducator.birth_year.valid}"
                                ></v-overflow-btn>
                            </v-flex>
                        </v-layout>

                        <v-layout row wrap>
                            <v-flex xs12 sm12 md12 lg12 xl12 class="text-xs-center">
                                <label for="" class="subheading">What is their email address?</label>
                            </v-flex>
                            <v-flex xs12 sm12 md12 lg12 xl12>
                                <label for="email_address" class="subheading">Email</label>
                                <v-text-field
                                    v-model="email_address"
                                    id="email_address"
                                    v-validate="'required|email'" 
                                    label="yourname@example.com"
                                    :error-messages="errors.first('formNewEducator.email_address')"
                                    data-vv-name="email_address"
                                    data-vv-scope="formNewEducator"
                                    :class="{valid_entry: fields.$formNewEducator && fields.$formNewEducator.email_address && fields.$formNewEducator.email_address.valid}"
                                    single-line
                                    outline
                                    class="full-width"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </form>
                </v-layout>
            </v-container>
            
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-layout row wrap align-center justify-center>
                <v-flex xs12 sm12 md12 lg12 xl12 align-center>
                    <v-btn round flat dark class="next-btn" @click="Confirm()" :class="{ next_btn_active: AllFieldsValid }">Confirm<span class="icon-next"><IconBase><IconForward /></IconBase></span></v-btn>
                </v-flex>
            </v-layout>
        </v-card-actions>
    </v-card>
</template>

<script>
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconBase from '@/components/IconBase.vue'
import IconForward from '@/components/icons/arrowForward.vue'
import IconCheck from '@/components/icons/check.vue'
import IconDualEducator from '@/components/icons/dualEducator.vue'
import Globals from '@/assets/scripts/global-functions.js'


export default {
    name: "ComponentEducatorForm",
    components: {
        IconArrowBack,
        IconBase,
        IconForward,
        IconCheck,
        IconDualEducator,
        Globals
    },
    props: ['current_process'],
    data: () => ({
        is_manual: true,
        month_of_the_year: [],
        years: [],
        days: [],
        educator_type: "",
        first_name: "",
        last_name: "",
        email_address: "",
        birth_day: "",
        birth_month: "",
        birth_year: "",
        dictionary: {
            custom: {
                first_name: {
                    required: () => "This field is required to proceed.",
                    max: 'Cannot exceed more than 100 characters'
                },
                last_name: {
                    required: () => "This field is required to proceed.",
                    max: 'Cannot exceed more than 100 characters'
                },
                email_address: {
                    required: () => "This field is required to proceed.",
                    email: 'You have entered an invalid email'
                },
                birth_day: {
                    required: () => "This field is required to proceed."
                },
                birth_month: {
                    required: () => "This field is required to proceed."
                },
                birth_year: {
                    required: () => "This field is required to proceed.",
                }
            }
        }
    }),
    computed: {
        AllFieldsValid: function() {
            let _isvalid = false;
            if(this.fields.$formNewEducator) {
                const fld = this.fields.$formNewEducator;
                if(fld.first_name) {
                    if(fld.first_name.valid && fld.first_name.valid && fld.last_name.valid && fld.last_name.valid && fld.email_address && fld.email_address.valid && fld.birth_day && fld.birth_day.valid && fld.birth_month && fld.birth_month.valid && fld.birth_year && fld.birth_year.valid && this.educator_type != "") { _isvalid = true; }
                }
            }
            

            return _isvalid;
        }
    },
    methods: {
        Confirm() {
            this.AddNewEducator();
        },
        ClearData() {
            this.educator_type = "";
            this.first_name = "";
            this.last_name = "";
            this.email_address = "";
            this.birth_day = "";
            this.birth_month = "";
            this.birth_year = "";
            this.$validator.reset();
        },
        AddSearchedAddress() {
        },
        AddNewEducator() {
            
            this.$validator.validateAll("formNewEducator").then(result => {
                if (result) {
                    let _data = {
                        "type": this.educator_type,
                        "first_name": this.first_name,
                        "last_name": this.last_name,
                        "email_address": this.email_address,
                        "birth_day": this.birth_day,
                        "birth_month": this.birth_month,
                        "birth_year": this.birth_year
                    } 
                    this.$root.$parent[this.current_process].Educators.push(_data);
                    Globals.SessionUpdate("EducatorInsuranceProcess", this.EducatorInsuranceProcess, true, "educator"); /* saved to session */
                    this.ClearData();
                    this.CloseModal();
                } else {
                    console.error("There seem to be an error in your entries.")
                }
            });
            
            
        },
        CloseModal() {
            this.ClearData();
            this.$emit('close-modal')
        },
        CreateNumberRange(_start, _end) {
            let _data = [];
            for(var i = _start; i <= _end; i++) {
                if(i < 10) { _data.push("0" + i); } else { _data.push(i); }
            }
            return _data;
        },
    },
    mounted () {
        this.$validator.localize('en', this.dictionary) 
        this.years = this.CreateNumberRange((new Date()).getFullYear() - 100,(new Date()).getFullYear());
        this.month_of_the_year = this.CreateNumberRange(1,12);
        this.days = this.CreateNumberRange(1,31);
    }
}
</script>

<style lang="scss" scoped>
    
</style>
